import React, { useState, useEffect, useCallback } from 'react';
import {Grid, Box, TextField, InputAdornment, IconButton, Button, Link, Typography, Slide, Collapse, Alert, Snackbar } from '@mui/material';
import './account.css';
import '../../styles/brandingStyles/branding.css';
import loginBanner from '../../assets/userAccount/loginBanner.png';
import TransLogo from '../../assets/KSKB_Logo_TransparentBG.PNG';
import { PersonOutline, LockOutlined, VisibilityOutlined, VisibilityOffOutlined, LoginOutlined, EmailOutlined } from '@mui/icons-material';
import axios from 'axios';
import { Link as RouterLink, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch,useSelector } from "react-redux";
import { updateUser } from '../../redux/userDetails';
import { useMediaQuery } from 'react-responsive';
import CustomAxios from '../../utils/CustomAxios';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
export function Login({ handleAuthLogin }){
    const [searchParams, setSearchParams] = useSearchParams();
    const activated = searchParams.get('activated') === '1';
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [email, setEmail] = useState('');
    const [toast, setToast] = useState({ open: false, message: '', severity: 'error' });
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [memberFlow, setMemberFlow] = useState(null);
    const [activationLinkSent, setActivationLinkSent] = useState(false);
    const navigate = useNavigate();
    const dispatch=useDispatch()
    const isMobile = useMediaQuery({ maxWidth: 600 })
    const handleTogglePasswordVisibility = () => {
      setShowPassword((prev) => !prev);
    };
    const showToast = useCallback((message, severity = 'error') => setToast({ open: true, message, severity }), []);
    const activationPasswordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{6,12}$/;
    const isActivationPasswordValid = activationPasswordRegex.test(password);
    const isActivationConfirmPasswordValid = activationPasswordRegex.test(confirmPassword);
   
    const handleLogin = (e) => {
        if(email===''){
            showToast("Please enter your username.");
            return;
        }
        if (password===''){
            showToast("Password is required.");
            return;
        }
        e.preventDefault();
        // Prepare payload
        const payload = {
          email: email,
            password: password,
            member_portal: window.location.origin === 'https://stage.members.kskb4391.org.my' ? true : false,
            // member_portal: window.location.origin === 'http://localhost:3000' ? true : false,
        };
    
        // Send data to the API endpoint using Axios
        CustomAxios.post(`oasis/MemberLogin/`, payload)
          .then(response => {
            // Successful login (status 200)
            console.log('API Response:', response.data);
            const auth_data = response.data;
            
            // Store user details in session storage
            window.sessionStorage.setItem('details', JSON.stringify(auth_data.user_details));
            
            // Check if first login - redirect to password reset
            if (auth_data.user_details["first-login"] === true) {
                navigate('/reset-password');
                return;
            }
            
            // Store additional user data
            window.sessionStorage.setItem('user_details', JSON.stringify({"member_role": auth_data.user_details.role}));
            console.log(response.data.member_data);
            dispatch(updateUser(response.data.member_data));
            window.sessionStorage.setItem("member", JSON.stringify({"member": response.data.member_data}));
            
            // Call the callback function to handle authentication in App.js
            handleAuthLogin(auth_data);

            // Redirect to the desired page after successful login
            auth_data.user_details.role === "member" ? navigate('/dashboard') : navigate('/add_member');
          })
          .catch(error => {
            // Handle different error status codes
            const status = error?.response?.status;
            const errorMessage = error?.response?.data?.error || 'An error occurred. Please try again.';
            
            if (status === 400) {
              // Bad Request - Account not activated or invalid input
              showToast(errorMessage, 'error');
            } else if (status === 401) {
              // Unauthorized - Incorrect password
              setPassword("");
              showToast(errorMessage || 'Invalid Credentials. Please try again.', 'error');
            } else if (status === 403) {
              // Forbidden - Access denied (non-member trying to access member portal)
              showToast(errorMessage || 'Access denied. This portal is only for members.', 'error');
            } else if (status === 404) {
              // Not Found - Member not found
              showToast(errorMessage || 'Member not found. Please check your credentials.', 'error');
            } else if (status === 500) {
              // Internal Server Error
              showToast(errorMessage || 'Server error. Please try again later.', 'error');
            } else {
              // Other errors
              showToast(errorMessage, 'error');
            }
          });
    };
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
          handleLogin(e); 
        }
    };
    
    const handleShowActivateForm = () => {
        if (email === '') {
            showToast('Please enter your Mykad number.');
            return;
        }
        setMemberFlow('activate');
    };

    const handleShowLoginForm = () => {
        setMemberFlow('login');
    };

    const handleSendActivationLink = async (e) => {
        e.preventDefault();
        if (email === '') {
            showToast('Please enter your Mykad number.');
            return;
        }
        if (password === '') {
            showToast('Please enter your password.');
            return;
        }
        if (confirmPassword === '') {
            showToast('Please re-enter your password.');
            return;
        }
        if (password !== confirmPassword) {
            showToast('Passwords do not match.');
            return;
        }
        if (!isActivationPasswordValid || !isActivationConfirmPasswordValid) {
            showToast('Password must contain letters and numbers, 6-12 characters.');
            return;
        }
        CustomAxios.post('oasis/send_activation_link/', {
            mykad: email,
            password: password,
        })
            .then((response) => {
                setActivationLinkSent(true);
            })
            .catch((error) => {
                showToast(error?.response?.data?.error||error?.response?.data?.message);
                console.error('Error:', error);
            });
    };
    const member = window.location.origin === 'https://stage.members.kskb4391.org.my'
    // const member = window.location.origin === 'http://localhost:3000'
    // const member = true
    useEffect(() => {
        if (activated) {
            if (member) setMemberFlow('login');
            setSearchParams({});
            showToast('Account activated successfully! You can now log in with your password.', 'success');
        }
    }, [activated, member, setSearchParams, showToast]);
    return(
        <Box sx={[isMobile&&{backgroundColor:"#F8FAFC",minHeight:"100vh"}]}>
            <Box sx={[isMobile && { backgroundColor: "#F8FAFC" }, { height: { xs: '100vh', sm: 'initial', md: '100vh' }, display: { sm: 'block', md: 'flex' }, flexDirection: 'column' }]}>
                <Grid container sx={[isMobile && { px: "1rem", pt: "20px" }, { height: { xs: '100vh', sm: 'initial', md: '100%' }, flex: { sm: 'none', md: 1 } }]} className='login-bg-primary'>
                {isMobile && <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', zIndex: 1,flexDirection: 'row', justifyContent: 'space-around' }}>
                        <Box component="img" sx={{ width: "50px", height: "50px" }} src={TransLogo}></Box>
                        <Box sx={{display:"flex", flexDirection:"column", gap:"5px",width:"80%"}}>   
                        <Typography sx={{ fontSize: "10px", fontWeight: 700, lineHeight: "12px", color: "black" }}>KOPERASI SERBAGUNA KEBANGSAAN BERHAD (4391)</Typography>
                        <Typography sx={{ fontSize: "10px", fontWeight: 500, lineHeight: "12px", color: "#636363" }}>Member Savings (Share & Subscription)</Typography>
                            <Typography sx={{ fontSize: "10px", fontWeight: 500, lineHeight: "12px", color: "#636363" }}>அங்கத்தினர் சேமிப்புகள் (பங்கு & சந்தா)</Typography>
                        </Box>
                </Box>}
                    <Grid item xs={12} sm={7} className={member ? '' : 'login-bg-primary'} sx={[{display: "flex", alignItems: "center", justifyContent: "center", position: "relative"}]}>
                        {!isMobile && <Box sx={{ position: "absolute", top: 35, left: 35, display: 'flex', alignItems: 'center', zIndex: 1 }}>
                            <Box component="img" sx={{width:"90px", height:"90px", mr: 2}} src={TransLogo}></Box>
                            <Box sx={{display:"flex", flexDirection:"column", gap:"8px"}}>
                            <Typography sx={{ fontSize: "20px", fontWeight: 700, lineHeight: "20px", color: "black" }}>KOPERASI SERBAGUNA KEBANGSAAN BERHAD (4391)</Typography>
                                <Typography sx={{ fontSize: "18px", fontWeight: 500, lineHeight: "20px", color: "#636363" }}>Member Savings (Share & Subscription)</Typography>
                                <Typography sx={{ fontSize: "14px", fontWeight: 500, lineHeight: "20px", color: "#636363" }}>அங்கத்தினர் சேமிப்புகள் (பங்கு & சந்தா)</Typography>
                            </Box>
                        </Box>}
                        
                        <Box component='img' sx={{width: { xs: "245px", sm: "300px", md:"500px",lg:"initial" }}} src={loginBanner} />
                    </Grid>
                    <Grid item xs={12} sm={5}  sx={{display: "flex", alignItems: "center", justifyContent: "center"}} >
                        {!member && <Box className='login-bg-primary-mem form' sx={[isMobile&&{p:2,backgroundColor:"#F8FAFC"}]}>
                            <form>
                                <Box sx={[isMobile&&{mt:"20px"},{mb:{xs:"12px",sm:1}}]} className='fn-h3 fw-600 primary text-center'>Login</Box>
                                <Box className='pgh-heading fw-600 text-center' style={{}}>Welcome back to Koperasi!</Box>
                                <Box className='pgh text-center'>Log in to your account to access all the great features of Koperasi.</Box>
                                <Box sx={{mt:{xs:"20px",sm:"30px"},mb:{xs:"20px",sm:4} }}>
                                    <Box sx={{mb:{xs:"20px",sm:4}}}>
                                        <Box sx={{mb:"8px", color:"#1E293B"}}>User Name <span style={{color:"#EF4444"}}>*</span></Box>
                                        <TextField
                                            placeholder="Email ID / Membership Number"
                                            fullWidth
                                            variant="outlined"
                                            sx={{mb:"8px"}}
                                            value={email}
                                            onKeyDown={(e)=>handleKeyPress(e)}
                                            onChange={(e) => setEmail(e.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                <InputAdornment position="start">
                                                    <PersonOutline />
                                                </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{mb:{xs:"20px",sm:4}}}>
                                        <Box sx={{mb:"8px", color:"#1E293B"}}>Password <span style={{color:"#EF4444"}}>*</span></Box>
                                        <TextField
                                            placeholder="Enter Password"
                                            fullWidth
                                            variant="outlined"
                                            type={showPassword ? 'text' : 'password'}
                                            sx={{mb:"8px"}}
                                            value={password}
                                            onKeyDown={(e)=>handleKeyPress(e)}
                                            onChange={(e) => setPassword(e.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                <InputAdornment position="start">
                                                    <LockOutlined />
                                                </InputAdornment>
                                                ),
                                                endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={handleTogglePasswordVisibility}>
                                                    {showPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined /> }
                                                    </IconButton>
                                                </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Box>

                                    <Button type="submit" fullWidth variant="contained" color="primary" onClick={handleLogin} startIcon={<LoginOutlined />}>
                                        Login
                                    </Button>
                                </Box>
                            </form>
                            <Box sx={{mb:4}} className='text-center'>
                                <Link className='link' color="secondary" component={RouterLink} to="/forgot-password">
                                    Forgot Password?
                                </Link>
                            </Box>
                            {/* <Box className='text-center'>
                                <Box>
                                    <span className='link'>Don’t have an account? </span>
                                    <Link component={RouterLink} to="/signup">
                                    Signup
                                    </Link>
                                </Box>
                            </Box> */}
                        </Box>}
                        {member && <Box sx={{ display: "flex", flexDirection: "column", gap: "20px",justifyContent: "center",alignItems: "center" }}>
                        <Box className='login-bg-primary-mem form' sx={[isMobile&&{mt:"20px"}]}>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", alignItems: "left", justifyContent: "center",alignItems:"center" }}>
                                <Typography sx={{ fontSize: {xs:"16px",sm:"20px"}, fontWeight: 700, lineHeight: {xs:"16px",sm:"20px"}, color: "black" ,textAlign:"center"}}>Welcome to the KSKB Member Portal</Typography>
                                <Typography sx={{ fontSize: { xs: "10px", sm: "14px" }, fontWeight: 500, lineHeight: { xs: "12px", sm: "16px" }, color: "#636363", textAlign: "center" }}> <span style={{ color: "black", fontWeight: 700 }}>கே.எஸ்.கே.பி</span>  அங்கத்தினர் போர்டலுக்கு வரவேற்கிறோம்</Typography>
                                <Typography sx={{ fontSize: {xs:"10px",sm:"12px"}, fontWeight: 700, lineHeight: {xs:"10px",sm:"12px"},color:"black",textAlign:"center" }}> Securely access your savings and investments information.</Typography>
                                <Typography sx={{ fontSize: {xs:"10px",sm:"10px"}, fontWeight: 400, lineHeight: {xs:"10px",sm:"10px"}, color: "#636363",textAlign:"center" }}> உங்கள் சேமிப்புகள் மற்றும் முதலீட்டு தகவல்களை பாதுகாப்பாக அணுகலாம்.</Typography>


                                {activationLinkSent ? (
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: { xs: "20px", sm: "20px" } }}>
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                        <Typography sx={{ fontSize: "16px", fontWeight: 600, color: "#22c55e" }}>Activation link sent!</Typography>
                                        <Typography sx={{ fontSize: "16px", fontWeight: 600, color: "#22c55e" }}>செயல்படுத்தல் இணைப்பு அனுப்பப்பட்டது!</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                        <Typography sx={{ fontSize: "14px", color: "#636363" }}>We have emailed you the activation link to your registered email address.</Typography>
                                        <Typography sx={{ fontSize: "14px", color: "#636363" }}>தாங்கள் பதிவு செய்துள்ள மின்னஞ்சல் முகவரிக்கு இணைப்பை நாங்கள் மின்னஞ்சல் செய்துள்ளோம்.</Typography>
                                        </Box>
                                        <Button fullWidth variant="contained" color="primary" sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.12)' }} onClick={() => { setActivationLinkSent(false); setMemberFlow(null); }}>Back</Button>
                                    </Box>
                                ) : (
                                    <form onSubmit={(e) => { e.preventDefault(); if (memberFlow === 'activate') handleSendActivationLink(e); else if (memberFlow === 'login') handleLogin(e); }} style={{ width: '100%' }}>
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px",mt:{xs:"20px",sm:"20px"} }}>
                                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                                <Box sx={{ color: "black", fontWeight: 700, fontSize: {xs:"14px",sm:"16px"}, lineHeight: {xs:"14px",sm:"24px"} }}>Mykad Number<span style={{ color: "#EF4444" }}>*</span></Box>
                                                <TextField
                                                        placeholder={"மைகார்ட் எண்"}
                                                        fullWidth
                                                        sx={{
                                                            "& .MuiInputBase-input": {
                                                                fontSize: {xs:"10px",sm:"12px"}
                                                            }
                                                        }}
                                                    variant="outlined"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    // disabled={memberFlow !== null}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <PersonOutline />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Box>

                                                <Collapse in={memberFlow === null} timeout={500}  >
                                                <Box sx={{ display: "flex", flexDirection: "column", gap:"10px" }}>
                                                    <Button fullWidth variant="contained" color="primary" onClick={handleShowActivateForm} sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.12)' }}>
                                                        <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                                            <Typography sx={{ fontSize: {xs:"10px",sm:"14px"}, fontWeight: 600 }}>Activate Account | கணக்கை இயக்கு</Typography>
                                                        </Box>
                                                    </Button>
                                                    <Button fullWidth variant="outlined" color="primary" onClick={handleShowLoginForm} sx={{ boxShadow: '0 2px 6px rgba(0,0,0,0.08)' }}>
                                                        <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                                            <Typography sx={{ fontSize: {xs:"10px",sm:"14px"}, fontWeight: 600 }}>Login | உள்நுழை</Typography>
                                                        </Box>
                                                    </Button>
                                                </Box>
                                            </Collapse>

                                                <Collapse in={memberFlow === 'activate'} timeout={500}  sx={{mt:{xs:"-10px",sm:"-10px"} }}>
                                            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                                    <Box sx={{ color: "black", fontWeight: 700, fontSize: {xs:"14px",sm:"16px"}, lineHeight: {xs:"14px",sm:"24px"} }}>Create New Password<span style={{ color: "#EF4444" }}>*</span></Box>
                                                    <TextField
                                                        placeholder="கடவுச்சொல்லை உள்ளிடவும்"
                                                                fullWidth
                                                                sx={{
                                                                    "& .MuiInputBase-input": {
                                                                        fontSize: {xs:"10px",sm:"12px"}
                                                                    }
                                                                }}
                                                        variant="outlined"
                                                        type={showPassword ? 'text' : 'password'}
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value.replace(/\s/g, ''))}
                                                        error={password.length > 0 && !isActivationPasswordValid}
                                                        helperText={password.length > 0 && !isActivationPasswordValid ? 'Use 6-12 characters with at least one letter and one number.' : null}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start"><LockOutlined /></InputAdornment>
                                                            ),
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton onClick={handleTogglePasswordVisibility} size="small">
                                                                        {showPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        inputProps={{ maxLength: 12 }}
                                                    />
                                                </Box>
                                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                                    <Box sx={{ color: "black", fontWeight: 700, fontSize: {xs:"14px",sm:"16px"}, lineHeight: {xs:"14px",sm:"24px"} }}>Re-enter New Password<span style={{ color: "#EF4444" }}>*</span></Box>
                                                    <TextField
                                                        placeholder="கடவுச்சொல்லை மீண்டும் உள்ளிடவும்"
                                                        fullWidth
                                                        sx={{
                                                            "& .MuiInputBase-input": {
                                                                fontSize: {xs:"10px",sm:"12px"}
                                                            }
                                                        }}
                                                        variant="outlined"
                                                        type={showConfirmPassword ? 'text' : 'password'}
                                                        value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value.replace(/\s/g, ''))}
                                                        error={(confirmPassword.length > 0 && !isActivationConfirmPasswordValid) || (confirmPassword.length > 0 && confirmPassword !== password)}
                                                        helperText={
                                                            confirmPassword.length > 0 && !isActivationConfirmPasswordValid
                                                                ? 'Use 6-12 characters with at least one letter and one number.'
                                                                : (confirmPassword.length > 0 && confirmPassword !== password ? 'Passwords do not match.' : null)
                                                        }
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start"><LockOutlined /></InputAdornment>
                                                            ),
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton onClick={() => setShowConfirmPassword((p) => !p)} size="small">
                                                                        {showConfirmPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        inputProps={{ maxLength: 12 }}
                                                    />
                                                </Box>
                                                        <Button
                                                            type="submit"
                                                            fullWidth
                                                            variant="contained"
                                                            color="primary"
                                                            disabled={!isActivationPasswordValid || !isActivationConfirmPasswordValid || password !== confirmPassword}
                                                            sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.12)' }}
                                                        >
                                                    <Box sx={{ display: "flex", flexDirection: "column", gap: "4px",justifyContent: "center",alignItems: "center" }}>
                                                            <Typography sx={{ fontSize: { xs: "12px", sm: "16px" }, fontWeight: 400, color: "white", textTransform: "none", textDecoration: "none", display: "flex", alignItems: "center", gap: "4px" }}>Send Activation Link </Typography>
                                                            <Typography sx={{ fontSize: { xs: "12px", sm: "16px" }, fontWeight: 400, color: "white", textTransform: "none", textDecoration: "none", display: "flex", alignItems: "center", gap: "4px" }}>செயல்படுத்தல் இணைப்பை அனுப்பு</Typography>
                                                        </Box>
                                                        </Button>
                                                <Button fullWidth variant="text" color="primary" onClick={() => { setMemberFlow(null); setPassword(''); setConfirmPassword(''); }}>
                                                    <Typography sx={{ fontSize: { xs: "12px", sm: "16px" }, fontWeight: 400, color: "#636363", textTransform: "none", textDecoration: "none", display: "flex", alignItems: "center", gap: "4px" }}><ArrowBackIosIcon sx={{ fontSize: { xs: "10px", sm: "16px" } }} />Back</Typography>
                                                </Button>
                                            </Box>
                                            </Collapse>

                                            <Collapse in={memberFlow === 'login'} timeout={500}  sx={{mt:{xs:"-10px",sm:"-15px"} }}>
                                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                                    <Box sx={{ color: "black", fontWeight: 700, fontSize: {xs:"14px",sm:"16px"}, lineHeight: {xs:"14px",sm:"24px"} }}>Password<span style={{ color: "#EF4444" }}>*</span></Box>
                                                    <TextField
                                                        placeholder="கடவுச்சொல்லை உள்ளிடவும்"
                                                        fullWidth
                                                        sx={{
                                                            "& .MuiInputBase-input": {
                                                                fontSize: {xs:"10px",sm:"12px"}
                                                            }
                                                        }}
                                                        variant="outlined"
                                                        type={showPassword ? 'text' : 'password'}
                                                        value={password}
                                                        onKeyDown={(e) => handleKeyPress(e)}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start"><LockOutlined /></InputAdornment>
                                                            ),
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton onClick={handleTogglePasswordVisibility} size="small">
                                                                        {showPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Box>
                                                <Button type="submit" fullWidth variant="contained" color="primary" sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.12)' }}>
                                                    <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                                                <Typography sx={{ fontSize: { xs: "10px", sm: "14px" }, fontWeight: 400, color: "white", textTransform: "none" }}>Access My Account | என் கணக்கை அணுகவும்</Typography>
                                                    </Box>
                                                </Button>
                                                <Box className='text-center'>
                                                    <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                                        <Typography sx={{ fontSize: {xs:"10px",sm:"16px"}, fontWeight: 400, color: "#636363", textTransform: "none",textDecoration:"none" }} component={RouterLink} to="/forgot-password">Forgot Password?</Typography>
                                                        <Typography sx={{ fontSize: {xs:"8px",sm:"10px"}, fontWeight: 400, color: "#636363", textTransform: "none",textDecoration:"none" }} component={RouterLink} to="/forgot-password">கடவுச்சொல்லை மறந்துவிட்டீர்களா?</Typography>
                                                    </Box>
                                                </Box>
                                                <Button fullWidth variant="text" color="primary" onClick={() => { setMemberFlow(null); setPassword(''); }}>
                                                            <Typography sx={{ fontSize: { xs: "10px", sm: "16px" }, fontWeight: 400, color: "#636363", textTransform: "none", textDecoration: "none", display: "flex", alignItems: "center", gap: "4px" }}><ArrowBackIosIcon sx={{ fontSize: { xs: "10px", sm: "16px" } }} />Back</Typography>
                                                </Button>
                                            </Box>
                                            </Collapse>
                                        </Box>
                                    </form>
                                )}
                                </Box>
                                <Box
                                    sx={{
                                        width: "100%",
                                        // mt: "24px",
                                        position: "relative",
                                        height: { xs: 130, sm: 160 },
                                        overflow: "hidden",
                                        borderRadius: "0 0 12px 12px",
                                    }}
                                >
                                    {/* LIGHT WAVE */}
                                    <svg
                                        viewBox="0 0 1200 120"
                                        preserveAspectRatio="none"
                                        style={{ position: "absolute", bottom: 0, width: "100%", height: "100%" }}
                                    >
                                        <path
                                            fill="#22c55e"
                                            d="M0,40 C200,90 400,0 600,40 C800,80 1000,20 1200,50 L1200,120 L0,120 Z"
                                        />
                                    </svg>

                                    {/* DARK WAVE */}
                                    <svg
                                        viewBox="0 0 1200 120"
                                        preserveAspectRatio="none"
                                        style={{ position: "absolute", bottom: 0, width: "100%", height: "100%" }}
                                    >
                                        <path
                                            fill="#FA5111"
                                            d="M0,60 C250,20 450,100 700,60 C900,30 1050,80 1200,60 L1200,120 L0,120 Z"
                                        />
                                    </svg>

                                    {/* SUPPORT BUTTON */}
                                    <Box
                                        sx={{
                                            position: "relative",
                                            zIndex: 2,
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            top: {xs:"35px",sm:"45px"}
                                        }}
                                    >
                                        <Button
                                            href="mailto:kskb.techsupport@arivu-iq.com"
                                            startIcon={<EmailOutlined sx={{ color: "#fff" }} />}
                                            sx={{
                                                color: "#fff",
                                                textTransform: "none",
                                                fontSize: { xs: "10px", sm: "12px" },
                                                fontWeight: 600,
                                            }}
                                        >
                                            SUPPORT | உதவி
                                        </Button>
                                    </Box>
                                </Box>
                        </Box>
                                {isMobile && <Box sx={{ mt: 'auto', py: 2, textAlign: 'center' }} className='login-bg-primary'>
                                    <Typography variant="body2" color="text.secondary" sx={[isMobile && { fontSize: '10px' }]}>
                                        Copyright © 2026 Koperasi Serbaguna Kebangsaan Berhad. All rights reserved.
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={[isMobile && { fontSize: '10px' }, { mt: 1 }]}>
                                        Powered by{' '}
                                        <Link
                                            href="https://arivu-iq.com/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{ color: 'primary.main', textDecoration: 'none' }}
                                        >
                                            AIQ
                                        </Link>
                                    </Typography>
                                </Box>}
                                </Box>
                        }
                    </Grid>
                </Grid>
                {!isMobile && <Box sx={{ mt: 'auto', py: 2, textAlign: 'center' }} className='login-bg-primary'>
                    <Typography variant="body2" color="text.secondary" sx={[isMobile && { fontSize: '10px' }]}>
                        Copyright © 2026 Koperasi Serbaguna Kebangsaan Berhad. All rights reserved.
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={[isMobile && { fontSize: '10px' }, { mt: 1 }]}>
                        Powered by{' '}
                        <Link
                            href="https://arivu-iq.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ color: 'primary.main', textDecoration: 'none' }}
                        >
                            AIQ
                        </Link>
                    </Typography>
                </Box>}
            </Box>
            <Snackbar
                open={toast.open}
                autoHideDuration={5000}
                onClose={() => setToast(t => ({ ...t, open: false }))}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                // TransitionComponent={(props) => <Slide {...props} direction="left" />}
            >
                <Alert
                    onClose={() => setToast(t => ({ ...t, open: false }))}
                    severity={toast.severity}
                    sx={{
                        width: '100%',
                        bgcolor: '#1a1a1a',
                        color: '#fff',
                        '& .MuiAlert-icon': { color: '#fff' },
                    }}
                >
                    {toast.message}
                </Alert>
            </Snackbar>
        </Box>
    )
};